// A super admin's read-only "view as" tab: every read of the desk token in THIS tab returns the preview token,
// and nothing in this tab can overwrite or clear the super admin's real session (shared localStorage).
const PREVIEW_KEY = "nex_preview_token";
const DESK_KEY = "nex_token";

if (sessionStorage.getItem(PREVIEW_KEY)) {
  const { getItem, setItem, removeItem } = Storage.prototype;
  Storage.prototype.getItem = function (k) {
    if (this === window.localStorage && k === DESK_KEY) return sessionStorage.getItem(PREVIEW_KEY) || getItem.call(this, k);
    return getItem.call(this, k);
  };
  Storage.prototype.setItem = function (k, v) {
    if (this === window.localStorage && k === DESK_KEY) return undefined;
    return setItem.call(this, k, v);
  };
  Storage.prototype.removeItem = function (k) {
    if (this === window.localStorage && k === DESK_KEY) return undefined;
    return removeItem.call(this, k);
  };
}
